import type { UserSubscriptionFragmentFragment } from '@lingoda/monolith-graphql';

export const isSubscriptionFFreeTrial = (
    subscription: Pick<UserSubscriptionFragmentFragment, 'paymentMethodAdded'> | null | undefined,
) => {
    return !!subscription && subscription.paymentMethodAdded !== null;
};
